<template lang="pug">
  div.text-center
    header
      main-header
    main.container
      el-row.container(
        type="flex",
        justify="center",
        :gutter="20"
      )
        p.text-center Clique sobre o botão correspondente ao perfil que deseja acessar o sistema:
      el-row.container(
        type="flex",
        justify="center",
        :gutter="20",
        v-if="perfis"
      )
        el-col(:xs="24", :sm="12", :md="8", :lg="6", :xl="4", v-for = "perfil in perfis", :key="perfil.id")
          .card(@click="setPerfilUsuario(perfil)")
            el-card
              div(slot="header")
                img.perfil(:src="imgPerfil(perfil)")
              div
                span {{ perfil.nome }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MainHeader from '@/components/MainHeader';
import { KEYS } from '@/store/local/localStorage';

export default {
  components: {
    MainHeader,
  },

  data() {
    return {
      perfis: [],
    };
  },

  async mounted() {
    this.perfis = await this.buscarPerfis();
    if (this.perfis && this.perfis.length == 1) {
      await this.selecionePerfil({ perfilId: this.perfis[0].id });
      window.location.href =
        this.usuario.urlModuloSelecionado +
        '?token=' +
        localStorage.getItem(KEYS.LOGIN.jwt).replace('Bearer ', '');
    }
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado',
    }),
  },

  methods: {
    ...mapActions({
      selecionePerfil: 'auth/selecionePerfil',
      buscarPerfis: 'auth/buscarPerfis',
    }),

    async setPerfilUsuario(perfil) {
      await this.selecionePerfil({ perfilId: perfil.id });
      window.location.replace(
        this.usuario.urlModuloSelecionado +
        '?token=' +
        localStorage.getItem(KEYS.LOGIN.jwt).replace('Bearer ', '')
      );
    },

    imgPerfil(perfil) {
      return require('@/assets/images/perfis/' + perfil.icone);
    },
  },
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}

.container {
  width: 100%;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  * {
    flex-wrap: wrap;
  }
}

.card {
  margin-bottom: 10px;
  flex-wrap: wrap;
  cursor: pointer;
  span{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
  }
  > :hover {
    transform: scale(1.05);
    transition-property: 2s;
  }
}

.perfil {
  width: 180px;
  height: 180px;
}
</style>
